import { useNavigate } from "react-router-dom";

import { sendEmailResetPassword } from "services/AuthenticationService";
import { useSnackbar } from "providers/SnackbarProvider";
import { useAppDispatch } from "store/store";
import {
  onFormChanges,
  setIsEmailExists,
} from "store/slicer/resetPasswordFormSlice";
import { EmailInput, GenericLandingCardHeader } from "./shared";
import {
  snackbarSeveritySuccess,
  snackbarSummarySuccessSendEmail,
  snackbarDetailSuccessSendEmail,
  ResetPasswordSubTitle,
  ResetPasswordTitle,
  formResetPassword,
} from "../_constants";

export const ResetPasswordForm = ({ control, handleSubmit, trigger }: any) => {
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    dispatch(onFormChanges(data));
    sendEmailResetPassword(data)
      .then((_) => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary: snackbarSummarySuccessSendEmail,
          detail: snackbarDetailSuccessSendEmail,
          life: 5000,
        });
        navigate("/verify-email-reset-password");
      })
      .catch((error) => {
        if (error.response.status === 404) {
          dispatch(setIsEmailExists(true));
        }
      });
  };
  return (
    <>
      <GenericLandingCardHeader
        title={ResetPasswordTitle}
        subtitle={ResetPasswordSubTitle}
      />
      <form
        className="margin-top-32"
        id={formResetPassword}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="width-100 flex-container justify-between wrap">
          <div className="width-100 margin-bottom-8">
            <EmailInput control={control} trigger={trigger} />
          </div>
        </div>
      </form>
    </>
  );
};
